<template>
  <div class="companyListBox">
       <el-table :data="tableData" border @row-click="goToProductInfo">
        <el-table-column prop="securityCode" label="证券代码" ></el-table-column>
        <el-table-column prop="securityName" label="证券简称"></el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import ssUtil from '@/utils/SStorage'

  export default {
    name: 'companyList',
    data() {
        return {
            tableData: []
        }
    },
    computed:{...mapState(['indexSearchInfo'])},
    created(){
        this.indexSearchInfo.forEach( item => {
            let params = {}
            params.securityName =  item.securityName;
            params.securityCode =  item.securityCode;
            params.coCode = item.coCode;
            this.tableData.push(params);
        });
    },
    methods: {
        //点击相应公司或者股票代码跳转至产品页
        goToProductInfo(row){
            let params = {
                type: 'company',
                coCode:row.coCode,
                securityCode:row.securityCode,
                name:row.securityName
            }
            this.$router.push({name:'productInfo',params:params})
        },

    },
    mounted() {

    }
  }
</script>

<style lang="scss" src="../sass/companyList.scss" ></style>



// WEBPACK FOOTER //
// src/components/companyList.vue